import React, {useContext, useEffect} from 'react'
import {Navigate, Outlet, useLocation, useNavigate} from 'react-router'

import AuthContext from '../contexts/AuthContext'
import Layout from '../components/ui/layout/Layout'
import Login from '../components/pages/login/Login.tsx'

const PrivateRoute = () => {
  const {isAuthenticated, user} = useContext(AuthContext)
  const {pathname} = useLocation()

  interface AuthenticatedInterface {
    pathname: string;
  }

  const Authenticated = ({pathname}: AuthenticatedInterface) => {
    const navigate = useNavigate()

    useEffect(() => {
      if (pathname === '/impersonate-login') {
        if (user.roles.indexOf('ROLE_ALLOWED_TO_SWITCH') >= 0) {
          window.location.reload()
        }

        navigate('/tableau-de-bord')
      }
    }, [user, pathname])

    return (
        <Layout>
          <Outlet />
        </Layout>
    )
  }

  return (
    (isAuthenticated && <Authenticated pathname={pathname} />)
    || (pathname === '/impersonate-login' && <Login impersonate={true} />)
    || (pathname === '/' && <Login impersonate={false} />)
    || <Navigate to={'/'} replace={true} />
  )
}

export default PrivateRoute
